import { UNLIMITED_CARD_STEPS } from 'routes/steps'
import { useApp } from 'store/steps'
import DesktopNavigation from './DesktopNavigation'

const UnlimitedCardDesktopNavigation = () => {
    const { stepId } = useApp()

    return <DesktopNavigation steps={UNLIMITED_CARD_STEPS} stepId={stepId} />
}

export default UnlimitedCardDesktopNavigation
